export default class DataSourceQuery {

    public static CreateDataSource = `mutation CreateProjectQuery($input: DataSourceInput) {
        createDataSource(input: $input) {
            id
        }
    }`;

    public static DeleteDataSource = `mutation DeleteProjectQuery($id: ID!) {
        deleteDataSource(id: $id) {
            id
        }
    }`;

    public static GetDataSources = `query GetDataSourcesQuery($projectId: String!) {
        getDataSources (
            projectId:$projectId
        ) {
            id
            projectId
            dataSourceName
            params
        }
    }`;
}